import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/admin/header/PageHeader";
import WorkspaceEditForm from "@/components/admin/workspace/WorkspaceEditForm";
import { routes } from "@/configs/router.config/routes";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { WorkspaceService } from "@/services/workspace/workspace.service";
import { showError, showSuccess } from "@/utils/notification";

const WorkspaceCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { mutate } = useWorkspaces();

  const submit = async (name: string, categoryMaxLevel: number) => {
    try {
      setIsLoading(true);
      await WorkspaceService.createWorkspace(name, categoryMaxLevel);
      await mutate();
      setIsLoading(false);
      showSuccess("ワークスペースを作成しました。");
      navigate(routes.workspaceList);
    } catch (error) {
      console.error(error);
      showError("ワークスペースの作成に失敗しました。");
    }
  };

  return (
    <>
      <PageHeader hasBack title="新規ワークスペース作成" />

      <WorkspaceEditForm submit={submit} isLoading={isLoading} />
    </>
  );
};

export default WorkspaceCreatePage;
